export default __webpack_public_path__ + "static/media/benefit_5@2x.ae24f849.png";